var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEth(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 14C0 6.268 6.268 0 14 0s14 6.268 14 14-6.268 14-14 14S0 21.732 0 14z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.09 4L7.779 14.4l6.313-2.732V4z",
    fill: "#8992B1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.778 14.401l-.004.007 1.29.691 5.027 2.698v-6.129l-6.313 2.733z",
    fill: "#656790"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.09 4v7.668l.078-.033 6.201 2.71L14.091 4z",
    fill: "#666690"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.407 14.407l-2.825 1.516-3.491 1.874v-6.129l.077-.033 6.201 2.71.038.062z",
    fill: "#474876"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.09 24v-5.235l-2.649-1.407-3.974-2.317L14.09 24z",
    fill: "#8A91B6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.74 17.358l-2.65 1.406V24l6.624-8.958v-.001l-3.974 2.317z",
    fill: "#61688A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14 27C6.82 27 1 21.18 1 14h-2c0 8.284 6.716 15 15 15v-2zm13-13c0 7.18-5.82 13-13 13v2c8.284 0 15-6.716 15-15h-2zM14 1c7.18 0 13 5.82 13 13h2c0-8.284-6.716-15-15-15v2zm0-2C5.716-1-1 5.716-1 14h2C1 6.82 6.82 1 14 1v-2z",
    fill: "#EAECF6"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCAyOCAyOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAgMTRDMCA2LjI2ODAxIDYuMjY4MDEgMCAxNCAwQzIxLjczMiAwIDI4IDYuMjY4MDEgMjggMTRDMjggMjEuNzMyIDIxLjczMiAyOCAxNCAyOEM2LjI2ODAxIDI4IDAgMjEuNzMyIDAgMTRaIiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTE0LjA5MDYgNEw3Ljc3NzgzIDE0LjQwMDZMMTQuMDkwNiAxMS42Njc3VjRaIiBmaWxsPSIjODk5MkIxIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNy43NzgyNSAxNC40MDEyTDcuNzc0MTcgMTQuNDA3N0w5LjA2MzEzIDE1LjA5OUwxNC4wOTEgMTcuNzk2OFYxMS42NjgzTDcuNzc4MjUgMTQuNDAxMloiIGZpbGw9IiM2NTY3OTAiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNC4wOTA4IDRWMTEuNjY3N0wxNC4xNjc1IDExLjYzNTFMMjAuMzY5MyAxNC4zNDUxTDE0LjA5MDggNFoiIGZpbGw9IiM2NjY2OTAiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yMC40MDY2IDE0LjQwNzRMMTcuNTgxNiAxNS45MjNMMTQuMDkwNiAxNy43OTY1VjExLjY2ODFMMTQuMTY4IDExLjYzNDZMMjAuMzY5MSAxNC4zNDU1TDIwLjQwNjYgMTQuNDA3NFoiIGZpbGw9IiM0NzQ4NzYiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNC4wOTA3IDIzLjk5OThWMTguNzY0OUwxMS40NDExIDE3LjM1NzdMNy40NjY1NSAxNS4wNDA3TDE0LjA5MDcgMjMuOTk5OFoiIGZpbGw9IiM4QTkxQjYiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNi43NDAyIDE3LjM1NzlMMTQuMDkwNiAxOC43NjQyVjI0TDIwLjcxMzkgMTUuMDQxNlYxNS4wNDA4TDE2Ljc0MDIgMTcuMzU3OVoiIGZpbGw9IiM2MTY4OEEiLz4KPHBhdGggZD0iTTE0IDI3QzYuODIwMyAyNyAxIDIxLjE3OTcgMSAxNEgtMUMtMSAyMi4yODQzIDUuNzE1NzMgMjkgMTQgMjlWMjdaTTI3IDE0QzI3IDIxLjE3OTcgMjEuMTc5NyAyNyAxNCAyN1YyOUMyMi4yODQzIDI5IDI5IDIyLjI4NDMgMjkgMTRIMjdaTTE0IDFDMjEuMTc5NyAxIDI3IDYuODIwMyAyNyAxNEgyOUMyOSA1LjcxNTczIDIyLjI4NDMgLTEgMTQgLTFWMVpNMTQgLTFDNS43MTU3MyAtMSAtMSA1LjcxNTczIC0xIDE0SDFDMSA2LjgyMDMgNi44MjAzIDEgMTQgMVYtMVoiIGZpbGw9IiNFQUVDRjYiLz4KPC9zdmc+Cg==";
export { SvgEth as ReactComponent };